import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
// import "../../assets/css/notchNav.css";

const NotchNav = ({ isLoggedIn }) => {
  let location = useLocation();
  const [activePage, setActivePage] = useState("");

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location]);

  if (!isLoggedIn) return null;

  return (
    <ul className="notch-nav">
      <li className="notch-nav-links">
        <Link to="/uploadCsv">
          <button
            className={`btn ${
              activePage === "/uploadCsv" ? "active-link" : ""
            }`}
            name="manage-data"
          >
            <i className="fas fa-table"></i>
          </button>
        </Link>
      </li>

      <li className="notch-nav-links">
        <Link to="/draw">
          <button
            className={`btn ${activePage === "/draw" ? "active-link" : ""}`}
            name="visualize-data"
          >
            <i className="fas fa-chart-line"></i>
          </button>
        </Link>
      </li>

      <li className="notch-nav-links">
        <Link to="/logout" name="logout">
          <button className=" btn">
            <i className="fas fa-power-off"></i>
          </button>
        </Link>
      </li>
    </ul>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.user.isLoggedIn,
});

export default connect(mapStateToProps)(NotchNav);
